import DropdownOption from "../dropdownOption";

export const ReceiptSortOptions: DropdownOption[] = [
    {
        value: "date",
        text: "Date",
        isSelected: false
    },
    {
        value: "name",
        text: "Name",
        isSelected: false
    },
    {
        value: "amount",
        text: "Amount",
        isSelected: false
    },
    {
        value: "occupation",
        text: "Occupation",
        isSelected: false
    },
    {
        value: "employer",
        text: "Employer",
        isSelected: false
    },
    {
        value: "city",
        text: "City",
        isSelected: false
    },
    {
        value: "state",
        text: "State",
        isSelected: false
    },
    {
        value: "zipCode",
        text: "Zip",
        isSelected: false
    },
]

export const ExpenditureSortOptions: DropdownOption[] = [
    {
        value: "date",
        text: "Date",
        isSelected: false
    },
    {
        value: "name",
        text: "Name",
        isSelected: false
    },
    {
        value: "amount",
        text: "Amount",
        isSelected: false
    },
    {
        value: "description",
        text: "Purpose",
        isSelected: false
    },
    {
        value: "city",
        text: "City",
        isSelected: false
    },
    {
        value: "state",
        text: "State",
        isSelected: false
    },
    {
        value: "zipCode",
        text: "Zip",
        isSelected: false
    },
]